import WhatsappCallsAPI from 'dashboard/api/channel/whatsapp/whatsappCallsAPI';
import { VOICE_CALL_OUTBOUND_INIT_STATUS } from 'dashboard/components-next/message/constants';
import { createVoiceWebrtcSession } from 'dashboard/composables/useVoiceWebrtcSession';

// Thin WhatsApp (Meta Cloud API) wrapper over the generic WebRTC plumbing in
// useVoiceWebrtcSession.js. Module-scoped instance → state is a singleton
// across every composable caller (header button + contact-panel button +
// bubble), same as before this was extracted (see phase-0-prep.md item 3).
const session = createVoiceWebrtcSession({
  api: WhatsappCallsAPI,
  apiUrlSegment: 'whatsapp_calls',
  remoteAudioElementId: 'whatsapp-call-remote-audio',
  logLabel: '[WhatsApp Call]',
  // BE returns 422 when the contact hasn't opted in (permission template sent
  // or already pending) — a WhatsApp/Meta-only concept. Surface it to the
  // caller as a normal response shape so it can render the banner instead of
  // an error toast; any other error still propagates as a throw.
  onInitiateError: e => {
    const data = e?.response?.data;
    if (
      data?.status === VOICE_CALL_OUTBOUND_INIT_STATUS.PERMISSION_REQUESTED ||
      data?.status === VOICE_CALL_OUTBOUND_INIT_STATUS.PERMISSION_PENDING
    ) {
      return { status: data.status, conversation_id: data.conversation_id };
    }
    return undefined;
  },
});

export const hasActiveWhatsappCall = () => session.hasActiveCall();

export const isLocalWhatsappCall = callId => session.isLocalCall(callId);

export function useWhatsappCallSession() {
  return session.useSession();
}

// Cable handlers fire outside any composable instance, so the shared session
// surface is exposed as module-level functions for them.

export const applyOutboundAnswer = (callId, sdpAnswer) =>
  session.applyRemoteAnswer(callId, sdpAnswer);

export const armOutboundRecorder = () => session.armOutboundRecorder();

export const cleanupWhatsappSession = () => session.cleanupSession();

export const handleWhatsappRemoteEnd = callId =>
  session.handleRemoteEnd(callId);

export const setWhatsappCallMuted = muted => session.setMuted(muted);

export const sendWhatsappTerminateBeacon = () => session.sendTerminateBeacon();
